export default __webpack_public_path__ + "static/media/lock.2c4ac2d8.svg";